import React from "react";
import Ayushreem from "../assets/case-studies/ayushreem-cs.png";

export default function AyushreemCaseStudy() {
  return (
    <div className="cs-pages">
      <img src={Ayushreem} alt="Ayushreem Hospital" width={"80%"} />
    </div>
  );
}
